import { PHASE_PRODUCTION_BUILD } from 'next/dist/shared/lib/constants'

import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod/v4'

const isBuildPhase = process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD

export const env = createEnv({
  client: {
    NEXT_PUBLIC_API_URL: z.url(),
    NEXT_PUBLIC_BASE_URL: z.url().default('http://localhost:3000'),
    NEXT_PUBLIC_DEV_MODE: z
      .enum(['true', 'false'])
      .optional()
      .transform((val) => val === 'true')
      .default(false),
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: z.string().min(1)
  },
  emptyStringAsUndefined: true,
  runtimeEnv: {
    JWT_SECRET_KEY: process.env.JWT_SECRET_KEY,
    NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_DEV_MODE: process.env.NEXT_PUBLIC_DEV_MODE,
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
  },
  server: {
    JWT_SECRET_KEY: isBuildPhase
      ? z.string().optional()
      : z
          .base64()
          .length(
            44,
            'JWT_SECRET_KEY must be exactly 44 characters (256-bit base64-encoded key)'
          )
  }
})
